import { render, staticRenderFns } from "./roadmap_settings.vue?vue&type=template&id=989c402e"
import script from "./roadmap_settings.vue?vue&type=script&lang=js"
export * from "./roadmap_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports